// extracted by mini-css-extract-plugin
export default {"baseInput":"_2TGf","textarea":"_1V5G"};